module.exports = __webpack_public_path__ + "img/3-2.f4923ea5.jpg";